import type { DmMessagePatientRow } from '../../../services/dmMessagesInbox';
import SlideOverModalLayout from '../../modals/SlideOverModalLayout';
import { DmPatientMessagesPanel } from '../../patient-files/actions/dm/DmPatientMessagesPanel';
import { DmMessagePanelHeader } from './DmMessagePanelHeader';
import { toAiReplySource } from './triage/aiTriageState';
import { useDmMessagePanelPatient } from './useDmMessagePanelPatient';

interface DmMessagePanelProps {
    patientId: string;
    // The patient's list row while it's listed, for the header and the to-review count.
    listed: DmMessagePatientRow | null;
    listSearch: string;
    onReviewed: (patientId: string) => Promise<void>;
    onClose: () => void;
}

export function DmMessagePanel({
    patientId,
    listed,
    listSearch,
    onReviewed,
    onClose
}: DmMessagePanelProps) {
    const { patient, unreviewedCount, triage, detail, isError } = useDmMessagePanelPatient(
        patientId,
        listed
    );
    const aiReply = detail ? toAiReplySource(detail) : undefined;

    return (
        <SlideOverModalLayout onClose={onClose} widthClass="w-2/5 min-w-[640px] max-w-[95vw]">
            <DmMessagePanelHeader
                patientId={patientId}
                patient={patient}
                patientError={isError}
                unreviewedCount={unreviewedCount}
                lastResolution={patient?.lastResolution ?? null}
                triage={triage}
                listSearch={listSearch}
                onReviewed={onReviewed}
            />
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white">
                <DmPatientMessagesPanel
                    key={patientId}
                    patientId={patientId}
                    aiReply={aiReply}
                    showHeader={false}
                    embedded
                />
            </div>
        </SlideOverModalLayout>
    );
}
